import { PageShell, Section } from "./PageShell";
import { useSeo } from "@/lib/useSeo";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy — NoobSync Brand Ambassador",
    description: "How NoobSync collects, uses, and protects your data in the Brand Ambassador Program, including your rights under the DPDP Act 2023.",
    path: "/privacy",
  });
  return (
    <PageShell
      kicker="Legal"
      title="Privacy Policy"
      lead="How NoobSync collects, uses and protects your data under the DPDP Act 2023."
    >
      <Section title="Information We Collect">
        <p>When you apply to the NoobSync Brand Ambassador program we collect: full name, email, city / state, the role type you select (student, working professional, brand, creator / influencer, etc.), and role-specific details (college, year, course for students; company, role, industry for working professionals; brand name, website, audience size for brands; content niche and primary platform for creators / influencers).</p>
        <p>We also collect your social media handles (Instagram, LinkedIn, YouTube, Twitter / X, optional others) and self-reported follower counts, content submissions and proof URLs / screenshots, referral activity (codes issued, signups, paid conversions), points history, and email engagement logs.</p>
      </Section>
      <Section title="How We Use Your Information">
        <p>Application review and selection, points tracking and leaderboard display, transactional emails (acceptance, content reviews, weekly digests, winner announcements), program operations and fraud prevention.</p>
      </Section>
      <Section title="Third-Party Services">
        <p>We use Brevo (Sendinblue) for transactional email delivery and an Emergent-managed object storage service for screenshot uploads. These providers process limited data only as needed to deliver the service.</p>
      </Section>
      <Section title="Data Security">
        <p>Data is stored on encrypted infrastructure. Authentication uses time-limited magic links — we never store passwords. Webhook integrations require an API key.</p>
      </Section>
      <Section title="Your Rights (DPDP Act 2023)">
        <p>You may request access to your data, correction of inaccuracies, deletion of your account, or withdrawal of consent at any time. Email <a href="mailto:info@noobsync.com" className="text-[#A855F7]">info@noobsync.com</a> with the subject &quot;DPDP Request&quot;.</p>
      </Section>
      <Section title="Data Retention">
        <p>Application data is retained for the duration of the cohort plus a reasonable period after (typically 12 months) for records, leaderboard archives, and fraud review. Deletion requests are honoured within 30 days.</p>
      </Section>
      <Section title="Cookies & Local Storage">
        <p>We use minimal local storage to store your login session token. We do not use third-party tracking cookies on this platform.</p>
      </Section>
      <Section title="Contact">
        <p>NoobSync Innovations · <a href="mailto:info@noobsync.com" className="text-[#A855F7]">info@noobsync.com</a></p>
      </Section>
    </PageShell>
  );
}
